const File = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
        <path d="m26.738 2.446 11.82 12.134h.234v.24l.795.816v29.918H8.413V2.446h18.325zm-3.68 4H12.412v35.107h23.175V18.58H23.058V6.445zm8.423 26.08v4H16.52v-4h14.96zm0-8.19v4H16.52v-4h14.96zm-4.423-15.83v6.074h5.917l-5.917-6.074z" />
    </svg>
);

export default File;
